(function () {
  function initMegaMenu() {
    var panels = document.querySelectorAll('.site-nav--has-megamenu');

    panels.forEach(function (panel) {
      var links = panel.querySelectorAll('.mega-menu-panel__link');
      var previewImg = panel.querySelector('.mega-menu-panel__preview-img');
      var previewTitle = panel.querySelector('.mega-menu-panel__preview-title');
      var previewDesc = panel.querySelector('.mega-menu-panel__preview-desc');

      function updatePreview(link) {
        var imgSrc = link.dataset.image;
        var desc = link.dataset.desc || '';
        var title = link.dataset.title || '';

        previewTitle.textContent = title;
        previewDesc.textContent = desc;

        if (imgSrc && imgSrc !== 'null' && imgSrc !== '') {
          previewImg.classList.remove('loaded');
          previewImg.src = imgSrc;
          previewImg.alt = title;
          previewImg.onload = function () {
            previewImg.classList.add('loaded');
          };
        } else {
          previewImg.src = '';
          previewImg.classList.remove('loaded');
        }
      }

      links.forEach(function (link) {
        link.addEventListener('mouseenter', function () {
          updatePreview(link);
        });
      });

      // 面板打开时默认显示第一个分类
      panel.addEventListener('mouseenter', function () {
        if (links.length > 0) {
          updatePreview(links[0]);
        }
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMegaMenu);
  } else {
    initMegaMenu();
  }
})();
